// extracted by mini-css-extract-plugin
export var aiChatCartContainer = "_by-2";
export var aiChatCartContainerExit = "_by-4";
export var aiChatContainerLarge = "_by-0";
export var aiChatContainerSmall = "_by-1";
export var aiChatIcon = "_by-6";
export var slideInFromRight = "_by-3";
export var slideOutToRight = "_by-5";